import { VStack } from "@chakra-ui/react";
import React from 'react';
import { MenuItem } from "./menu-item";
export const SideNavigation = (props) => {
    return (React.createElement(VStack, { w: "100%", alignItems: "stretch", overflowX: "auto" }, props.pages.map(page => (React.createElement(MenuItem, { key: page.id, page: page })))));
};
